export default "__VITE_ASSET__Bdd7UjvI__"